import { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

import { ClassName } from "shared/types";
import { Icon, IconName } from "shared/ui/icon";

type Props = { iconName: IconName; isActive?: boolean } & ClassName;

export const Item = (props: PropsWithChildren<Props>) => {
  const { className, iconName, children, isActive } = props;

  return (
    <span
      className={twMerge(
        "hover:bg-softPeach/50 flex grow items-center gap-x-3 overflow-hidden rounded-md px-3 py-2 whitespace-nowrap transition-colors",
        isActive && "bg-softPeach/50",
        className
      )}
    >
      <Icon className="text-mistBlue shrink-0" name={iconName} />
      {children}
    </span>
  );
};
